import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { useStoreSelector } from 'v3/data/store';
import { StoreProfileEnum } from 'v3/data/store/stores/enums';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { AlignMobileButtons, Container, Content, Header } from 'v3/pages/Stores/List/styles';
import { RoutesEnum } from 'v3/routes/enum';
import { CircularButton } from 'v3/shared/components/Button/CircularButton';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { StoreListFilter } from 'v3/shared/components/Filters/StoreListFilter';
import { StoresTable } from 'v3/shared/components/Table/StoresTable';
import { CommonTemplate } from 'v3/shared/templates/CommonTemplate';
import { HeadlineMedium } from 'v3/shared/typography/HeadlineMedium';

export const StoresList = () => {
  const { group } = useStoreSelector((store) => store.store.storeLogged);
  const isAdmin = group === StoreProfileEnum.MASTER_ADMIN;
  const { isMobile } = useBreakpoints();
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate(RoutesEnum.CreateStore);
  };

  return (
    <CommonTemplate>
      <Container>
        <Content>
          <Header>
            <HeadlineMedium>Lista de Lojas</HeadlineMedium>

            {isAdmin &&
              (isMobile ? (
                <AlignMobileButtons>
                  <CircularButton startIcon={AddIcon} handleClick={handleButtonClick} />
                </AlignMobileButtons>
              ) : (
                <FlexButton size="small" text="Adicionar loja" handleClick={handleButtonClick} startIcon={AddIcon} />
              ))}
          </Header>
          <StoreListFilter />
          <StoresTable />
        </Content>
      </Container>
    </CommonTemplate>
  );
};
